module.exports = __webpack_public_path__ + "img/rg.02eadb4e.svg";